import { render, staticRenderFns } from "./MaxLikeInteractionsCard.vue?vue&type=template&id=b1edf578&scoped=true"
import script from "./MaxLikeInteractionsCard.vue?vue&type=script&lang=ts"
export * from "./MaxLikeInteractionsCard.vue?vue&type=script&lang=ts"
import style0 from "./MaxLikeInteractionsCard.vue?vue&type=style&index=0&id=b1edf578&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1edf578",
  null
  
)

export default component.exports